/** 案件区分 */
export const caseCategorys = {
  /** 1:通常*/
  Normal: "1",
  /** 2:稟議書 */
  Approval: "2",
  /** 3:赤黒調整 */
  reversalAndCorrecting: "3",
};
